import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/store/auth.store";
import { roleDashboardPath } from "@/router/roleDashboardPath";

/**
 * Interdit les écrans d'authentification (ex. /login) à un utilisateur déjà
 * connecté : il est renvoyé vers le tableau de bord de son rôle.
 */
export function RedirectIfAuthenticated() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const role = useAuthStore((s) => s.role);

  if (!isAuthenticated || role === "guest") return <Outlet />;

  return <Navigate to={roleDashboardPath(role)} replace />;
}
